<template>
    <div>
        <vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <h5>Logo</h5>
                <div class="flex flex-1 mt-5">
                <div class="flex flex-col">
                    <vs-avatar :src="themeSettings.logo_url" size="70px" class="mr-4 mb-4 object-contain" />
                </div>
                <div class="flex flex-col ml-10">
                    <div class="flex">
                    <vs-button @click="changeLogo = !changeLogo">Change Logo</vs-button>
                    <vs-button @click="removeLogo()" class="ml-6" type="border">Reset</vs-button>
                    </div>
                    <div class="flex justify-center mt-2">
                    <p class="text-sm mt-2">Allowed JPG, JPEG or PNG. Max size of 50kb</p>
                    </div>
                </div>
                </div>
                <div v-if="changeLogo" class="cstm_vuefileagent_holder w-full">
                <file-upload-component
                    section_type="courseHeader"
                    @getImage="getImageUrl"
                    :file_repository_id="repository_id"
                ></file-upload-component>
                </div>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <h5>Colors</h5>
                <div class="flex flex-wrap mt-5">
                <div class="p-2">
                    <h6 class="mb-3">PRIMARY</h6>
                    <div class="theme_color_holder">
                    <div class="color_holder" :style="{backgroundColor: themeSettings.primary}"></div>
                    <span class="material-icons">expand_more</span>
                    <input type="color" v-model="themeSettings.primary" />
                    </div>
                </div>
                <div class="p-2">
                    <h6 class="mb-3">SECONDARY</h6>
                    <div class="theme_color_holder">
                    <div class="color_holder" :style="{backgroundColor: themeSettings.secondary}"></div>
                    <span class="material-icons">expand_more</span>
                    <input type="color"  v-model="themeSettings.secondary" />
                    </div>
                </div>
                <div class="p-2">
                    <h6 class="mb-3">HEADING</h6>
                    <div class="theme_color_holder">
                    <div class="color_holder" :style="{backgroundColor: themeSettings.heading}"></div>
                    <span class="material-icons">expand_more</span>
                    <input type="color"  v-model="themeSettings.heading" />
                    </div>
                </div>
                <div class="p-2">
                    <h6 class="mb-3">TEXT</h6>
                    <div class="theme_color_holder">
                    <div class="color_holder" :style="{backgroundColor: themeSettings.text}"></div>
                    <span class="material-icons">expand_more</span>
                    <input type="color" v-model="themeSettings.text" />
                    </div>
                </div>
                </div>
            </vs-col>
        </vs-row>

        <vs-card class="cstm-card">
              <div class="text-center">
                <svg style="width: 80px; height: 80px;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" fill="#5FCDFF" stroke="#119CDB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" fill="#FFE350" stroke="#FF8E24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20 8V14" stroke="#00B6C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 11H17" stroke="#00B6C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p style="font-size: 16px; font-weight: 600;" class="mb-3">Send automatic. Sign Up invitation</p>
                <vs-switch class="mx-auto sign_up_toggle" v-model="themeSettings.invitation_setting">
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>
              </div>
            </vs-card>

        <vs-divider />

        <div>
            <h5 class="mb-4">Email Settings</h5>
            <vs-row>                
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <content-component
                        v-model="header"
                        :file_repository_id="repository_id"

                        label="Email Header"
                    ></content-component>
                    <vs-button class="block ml-auto my-4" @click.prevent="previewHeaderFooter()">Preview</vs-button>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <content-component
                        v-model="footer"
                        :file_repository_id="repository_id"

                        label="Email Footer"
                    ></content-component>
                    <vs-button class="my-4" @click.prevent="verification()">Verification</vs-button>
                </vs-col>
            </vs-row>
        </div>

        <vs-divider />

        <vs-button class="block mx-auto" @click.prevent="saveSettings()">Update Settings</vs-button>

         <vs-popup  title="Preview Header and Footer" :active.sync="previewHeaderFooterModal">
          <p v-html="header"></p>
          <p>Content</p>
          <p v-html="footer"></p>

      </vs-popup>
    </div>
</template>

<script>

import { repository } from '@/mixins/repository'
import {  verificationMailSend } from '@/api/setting.js'


import FileUploadComponent from '@/views/pages/settings/components/FileUploadComponent.vue'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'


export default {
  mixins: [repository],
  props:{
    header:{
      default:''
    },
    footer:{
      default:''
    },
    themeSettings:{
      default:''
    }
  },
  created () {
    this.getRepositoryId(this.platform_module_id)
  },
  data () {
    return {
      previewHeaderFooterModal:false,
      changeLogo: false,
      platform_module_id: 3

    }
  },
  components: {
    FileUploadComponent,
    ContentComponent
  },
  methods: {
    saveSettings () {
      console.log(this.themeSettings)
      const payload = {
        header: this.header,
        footer:this.footer,
        primary_color: this.themeSettings.primary,
        secondary_color: this.themeSettings.secondary,
        heading_color: this.themeSettings.heading,
        text_color: this.themeSettings.text,
        logo: this.themeSettings.logo_url,
        invitation_setting:this.themeSettings.invitation_setting
      }
          
      this.$emit('saveThemeSetting', payload)
    },
    previewHeaderFooter () {
      this.previewHeaderFooterModal = true
    },
    async verification () {
      try {
        const payload = {
          header:this.header,
          footer:this.footer
        }
        const customer_id = localStorage.getItem('customer_id')
        await verificationMailSend(customer_id, payload)
        this.showSuccessMessage('Success', 'Verification Mail sent Successfully', 'success')
      } catch (error) {
        console.log(error)
      }
    },

    removeLogo () {
      this.themeSettings.logo_url = 'https://scoolio-dev.track-progress.com/img/scoolio.8c3f7f84.svg'
    },
    getImageUrl (obj) {
      
      this.themeSettings.logo_url = obj.file_image_url
      console.log(this.themeSettings.logo_url)
    },
    resetSettings () {
      this.themeSettings.primary = '#3ac2d4'
      this.themeSettings.secondary = '#f67c7e'
      this.themeSettings.heading = '#2c2c2c'
      this.themeSettings.text = '#626262'
    }
  }
}
</script>